import type {Currency, Price} from '@cohort/shared/schema/common/currency';
import {formatAmount} from '@cohort/shared/utils/format';
import {InformationTootlip} from '@cohort/wallet/components/modals/InformationTooltip';
import SelectCurrencyModal from '@cohort/wallet/components/modals/store/SelectCurrencyModal';
import {useGeolocationStore} from '@cohort/wallet/hooks/stores/geolocation';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';

interface Props {
  price: Price;
  prices: Price[];
  setCurrency: (currency: Currency) => void;
}

const PriceLabel = ({price, prices, setCurrency}: Props): React.ReactElement => {
  const {t} = useTranslation('components', {keyPrefix: 'store.priceLabel'});
  const [modalOpened, setModalOpened] = useState(false);
  const availableCurrencies = prices.map(price => price.currency);
  const {geolocation} = useGeolocationStore();

  return (
    <div className="mt-2 flex">
      {modalOpened && (
        <SelectCurrencyModal
          currentCurrency={price.currency}
          availableCurrencies={availableCurrencies}
          setCurrency={setCurrency}
          setModalOpened={setModalOpened}
        />
      )}
      <div className="items-top flex">
        <span>{formatAmount(price.amount, price.currency)}</span>
        {geolocation?.continentCode === 'EU' && (
          <InformationTootlip className="ml-1">{t('taxIncluded')}</InformationTootlip>
        )}

        {prices.length > 1 && (
          <span className="ml-2 flex">
            {'('}
            <button
              type="button"
              className="text-blue-500 underline"
              onClick={() => setModalOpened(true)}
            >
              {price.currency.toUpperCase()}
            </button>
            {')'}
          </span>
        )}
      </div>
    </div>
  );
};

export default PriceLabel;
